import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DecimalPipe } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-gas-consumption-quartal-chart',
  standalone: true,
  imports: [ChartModule],
  providers: [DecimalPipe],
  templateUrl: './gas-consumption-quartal-chart.component.html',
  styleUrl: './gas-consumption-quartal-chart.component.css'
})
export class GasConsumptionQuartalChartComponent implements OnChanges {
  data: any;
  options: any;

  // Dummy data
  @Input() showDummyData: boolean = false;
  dummysmcQuarterData: number[] = [31000, 29000, 27000, 33000];

  @Input() smcQuarterData: number[] = [31000, 29000, 27000, 33000];
  @Input() year: number = new Date().getFullYear();

  labels: string[] = ['Q1 /24', 'Q2 /24', 'Q3 /24', 'Q4 /24'];
  quartalQ1Translation: string = "Q1";
  quartalQ2Translation: string = "Q2";
  quartalQ3Translation: string = "Q3";
  quartalQ4Translation: string = "Q4";

  constructor(private decimalPipe: DecimalPipe, private translocoService: TranslocoService) { }

  ngOnChanges(changes: SimpleChanges): void {
    combineLatest([
      this.translocoService.selectTranslate('dashboard.quartal.Q1'),
      this.translocoService.selectTranslate('dashboard.quartal.Q2'),
      this.translocoService.selectTranslate('dashboard.quartal.Q3'),
      this.translocoService.selectTranslate('dashboard.quartal.Q4'),
    ]).subscribe((
      [
        quartalQ1Translation,
        quartalQ2Translation,
        quartalQ3Translation,
        quartalQ4Translation
      ]
    ) => {
      this.quartalQ1Translation = quartalQ1Translation;
      this.quartalQ2Translation = quartalQ2Translation;
      this.quartalQ3Translation = quartalQ3Translation;
      this.quartalQ4Translation = quartalQ4Translation;
    });

    this.updateChart();
  }

  updateChart(): void {
    if (this.showDummyData) {
      this.smcQuarterData = this.dummysmcQuarterData;
    }

    this.labels = [`${this.quartalQ1Translation} /${this.year}`, `${this.quartalQ2Translation} /${this.year}`, `${this.quartalQ3Translation} /${this.year}`, `${this.quartalQ4Translation} /${this.year}`];
    Chart.register(ChartDataLabels);

    this.data = {
      labels: this.labels,
      datasets: [
        {
          type: 'bar',
          label: 'SMC',
          data: this.smcQuarterData,
          backgroundColor: ['#7EA4A4', '#6F9A9A', '#89B3B3', '#7DADAD'],
          borderRadius: 12,
          datalabels: {
            display: true,
            clamp: true,
            align: 'top',
            anchor: 'auto',
            color: '#000000',
            font: {
              size: 10,
              weight: 'normal',
              family: 'Gilroy',
            },
            textAlign: 'center',
            formatter: (value: number) => { if (value == 0) { return ''; } return `${this.decimalPipe.transform(value, '1.0-0') || value} \nsmc` },
          },
        },
      ],
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const index = context.dataIndex;
              let label = context.dataset.label || '';
              let value = context.raw || 0;
              return `${label}: ${this.decimalPipe.transform(value, '1.0-0') || value}`;
            }
          }
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            font: {
              weight: 'normal',
              size: 12,
              family: 'Gilroy',
            },
            color: '#000',
          },
        },
        y: {
          beginAtZero: true,
          ticks: {
            display: false,
          },
          grid: {
            display: false,
          },
        },
      },
    };
  }
}